import React from 'react';
import { Box, Typography, Container } from '@mui/material';

/**
 * PageTitleContainer component
 * A standardized container for page titles used across the application
 *
 * @param {Object} props - Component props
 * @param {string} props.title - The title to display
 * @param {React.ReactNode} props.rightContent - Optional content to display on the right side
 * @param {string} props.justifyContent - Optional CSS justify-content value for the header area (default: 'space-between')
 * @param {Object} props.sx - Optional additional styles
 * @param {Object} props.titleProps - Optional props for the title Typography
 * @param {React.ReactNode} props.children - Optional children to render below the title
 * @returns {React.ReactElement} PageTitleContainer component
 */
const PageTitleContainer = ({
  title,
  rightContent,
  justifyContent = 'space-between',
  sx = {},
  titleProps = {},
  children
}) => {
  return (
    <Box
      className="page-title-container"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        mb: 3,
        pl: 5,
        pr: 5,
        py: 2, // Exactly 16px padding (MUI's spacing unit of 2 equals 16px)
        bgcolor: 'white',
        borderRadius: '4px',
        width: '100%',
        ...sx
      }}
    >
      <Container maxWidth={false} sx={{ px: 0, width: '100%', maxWidth: '100% !important' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: justifyContent,
            alignItems: 'center',
            width: '100%'
          }}
        >
          <Typography 
            variant="h5" 
            component="h1" 
            fontWeight={600}
            {...titleProps}
          >
            {title}
          </Typography>
          
          {rightContent && (
            <Box>
              {rightContent}
            </Box>
          )}
        </Box>
        
        {children && (
          <Box sx={{ mt: 1 }}>
            {children}
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default PageTitleContainer;